import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PlanServices from '../../services/PlanServices';
import useAsync from '../../hooks/useAsync';
import CategoryServices from '../../services/CategoryServices';
import Select from "react-select";

function AddPlan() {
  const navigate = useNavigate();
  const { data } = useAsync(CategoryServices.getCategory);
  console.warn(data.data);

  const [formValues, setFormValues] = useState({
    planType: "Fixed",
    planName: '',
    mainAmount: null,
    offerPrice: null,
    noOfMonth: null,
    termsAndConditions: "",
    percentageOrderAmount: null,
    numberOfBookings: null,
    discountAmount: null,
    totalServices: null,
    numberOfBookingsParMonth: null,
    benefits: [],
    category: [],
  });

  const categoryOptions = data?.data?.map((cat) => ({
    value: cat._id,
    label: cat.title,
  })) || [];


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const updatedValues = {
      ...formValues,
      [name]: value,
    };

    if (name === "noOfMonth" && (value < 1 || value > 12)) {
      alert("Please enter a valid month between 1 and 12.");
      return;
    }

    if (name === "discountAmount") {
      const numValue = parseFloat(value);
      if (!Number.isInteger(numValue)) {
        const nearestWhole = Math.round(numValue);
        alert(`Please enter a whole number. The nearest valid values are ${nearestWhole - 1} and ${nearestWhole + 1}`);
        return;
      }
      if (numValue < 0) {
        alert("Discount amount cannot be negative");
        return;
      }
    }

    if ((name === "mainAmount" || name === "offerPrice") &&
      updatedValues.mainAmount && updatedValues.offerPrice) {
      const mainAmount = parseFloat(updatedValues.mainAmount);
      const offerPrice = parseFloat(updatedValues.offerPrice);

      if (!isNaN(mainAmount) && !isNaN(offerPrice) && mainAmount > 0) {
        const discountPercent = ((mainAmount - offerPrice) / mainAmount) * 100;
        updatedValues.discountAmount = Math.round(discountPercent);
      }
    }


    setFormValues(updatedValues);
  };



  const handleMultiSelectChange = (selectedOptions) => {
    setFormValues({
      ...formValues,
      category: selectedOptions.map((option) => option.value),
    });
  };



  const handleBenefitChange = (index, event) => {
    const updatedBenefits = formValues.benefits.map((benefit, i) =>
      i === index ? event.target.value : benefit
    );
    setFormValues({
      ...formValues,
      benefits: updatedBenefits,
    });
  };


  const addBenefit = () => {
    setFormValues({
      ...formValues,
      benefits: [...formValues.benefits, ''],
    });
  };


  const removeBenefit = (index) => {
    const updatedBenefits = formValues.benefits.filter((_, i) => i !== index);
    setFormValues({
      ...formValues,
      benefits: updatedBenefits,
    });
  };


  const validateForm = () => {
    const { mainAmount, offerPrice } = formValues;
    if (parseFloat(offerPrice) >= parseFloat(mainAmount)) {
      alert('Offer Price must be less than the Main Amount.');
      return false;
    }

    return true;
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;
    try {
      const formData = new FormData();

      for (const key in formValues) {
        formData.append(key, formValues[key]);
      }

      formValues.benefits.forEach((benefit, index) => {
        formData.append(`benefits[${index}]`, benefit);
      });

      const response = await PlanServices.createPlan(formValues);
      alert('Plan Added Successfully');
      navigate('/plan')
    } catch (error) {
      console.error('Failed to plan details', error);
      alert(error.response?.data?.message || 'Failed to add plan details');
    }
  };



  return (
    <>
      <div className="right_col" role="main">
        <div className="title-box">
          <h2>Plan Add</h2>
          <div className="container-box-top-header-right">
            <Link className="list-banner-btn" to="/plan">
              Plan List
            </Link>
          </div>
        </div>
        <div className="container-box px-5">
          <div className="container-box-inner">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    <div className="input-field d-flex align-items-center gap-1">
                      <input
                        type="radio"
                        name="planType"
                        value="Fixed"
                        checked={formValues.planType === "Fixed"}
                        onChange={handleInputChange}
                        className="mr-2"
                      />
                      <label className="mb-0">Fixed</label>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6">
                    <div className="input-field d-flex align-items-center gap-1">
                      <input
                        type="radio"
                        name="planType"
                        value="Percentage"
                        checked={formValues.planType === "Percentage"}
                        onChange={handleInputChange}
                        className="mr-2"
                      />
                      <label className="mb-0">Percentage</label>
                    </div>
                  </div>

                  {/* Common Fields */}
                  <div className="col-lg-6 col-md-6">
                    <div className="input-field">
                      <label>Plan Name<span className="red">*</span></label>
                      <input
                        type="text"
                        name="planName"
                        className="form-control"
                        value={formValues.planName}
                        onChange={handleInputChange}
                        placeholder="Plan Name"
                        required
                      />
                    </div>
                  </div>


                  <div className="col-lg-6 col-md-6">
                    <div className="input-field">
                      <label>Amount<span className="red">*</span></label>
                      <input
                        type="number"
                        name="mainAmount"
                        className="form-control"
                        value={formValues.mainAmount}
                        onChange={handleInputChange}
                        placeholder="Enter Amount"
                        min="0"
                        step="0"
                        required
                      />
                    </div>
                  </div>


                  <div className="col-lg-6 col-md-6">
                    <div className="input-field">
                      <label>Month<span className="red">*</span></label>
                      <select
                        name="noOfMonth"
                        className="form-control"
                        value={formValues.noOfMonth || ""}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="" disabled selected hidden>Please select month</option>
                        {[...Array(12)].map((_, i) => (
                          <option key={i} value={i + 1}>{i + 1}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="input-field">
                      <label>Offer Price<span className="red">*</span></label>
                      <input
                        type="number"
                        name="offerPrice"
                        className="form-control"
                        value={formValues.offerPrice}
                        onChange={handleInputChange}
                        placeholder="Enter Offer Price"
                        min="0"
                        step="0"
                        required
                      />
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6">
                    <div className="input-field">
                      <label>Benefits<span className="red">*</span></label>
                      {formValues.benefits.map((benefit, index) => (
                        <div key={index} className="input-group mb-2">
                          <input
                            type="text"
                            className="form-control"
                            value={benefit}
                            onChange={(event) =>
                              handleBenefitChange(index, event)
                            }
                            placeholder="Benefit description"
                            required
                          />
                          <div className="input-group-append">
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => removeBenefit(index)}
                            >
                              &times;
                            </button>
                          </div>
                        </div>
                      ))}
                      <button
                        type="button"
                        className="btn btn-secondary mt-2"
                        onClick={addBenefit}
                      >
                        + Add Benefit
                      </button>
                    </div>
                  </div>


                  {formValues.planType === "Fixed" && (
                    <>

                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Discount Amount (%)<span className="red">*</span></label>
                          <input
                            type="number"
                            name="discountAmount"
                            className="form-control"
                            value={formValues.discountAmount}
                            onChange={handleInputChange}
                            placeholder="Enter whole number percentage"
                            min="0"
                            step="1"
                            required
                          />
                          {formValues.discountAmount % 1 !== 0 && (
                            <div className="error-message">
                              Please enter a whole number. Nearest values: {Math.floor(formValues.discountAmount)} and {Math.ceil(formValues.discountAmount)}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Total Number of Services<span className="red">*</span></label>
                          <input
                            type="number"
                            name="totalServices"
                            className="form-control"
                            value={formValues.totalServices}
                            onChange={handleInputChange}
                            placeholder="Enter Total Number of Services"
                            min="1"
                            required
                          />
                        </div>
                      </div>


                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Total Number of Services Per Month<span className="red">*</span></label>
                          <input
                            type="number"
                            name="numberOfBookingsParMonth"
                            className="form-control"
                            value={formValues.numberOfBookingsParMonth}
                            onChange={handleInputChange}
                            placeholder="Enter Total Number of Services Per Month"
                            min="1"
                            required
                          />
                        </div>
                      </div>


                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Select Category<span className="red">*</span></label>
                          <Select
                            options={categoryOptions}
                            isMulti
                            name="category"
                            value={
                              categoryOptions.length > 0 && formValues.category
                                ? categoryOptions.filter((opt) =>
                                  formValues.category.includes(opt.value)
                                )
                                : []
                            }
                            onChange={handleMultiSelectChange}
                            placeholder="Select categories..."
                          />

                        </div>
                      </div>


                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Terms and Conditions<span className="red">*</span></label>
                          <textarea
                            name="termsAndConditions"
                            className="form-control h-auto"
                            value={formValues.termsAndConditions}
                            onChange={handleInputChange}
                            placeholder="Enter terms and conditions"
                            required
                          />
                        </div>
                      </div>
                    </>
                  )}

                  {formValues.planType === "Percentage" && (
                    <>
                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Discount Amount<span className="red">*</span></label>
                          <input
                            type="number"
                            name="discountAmount"
                            className="form-control"
                            value={formValues.discountAmount}
                            onChange={handleInputChange}
                            placeholder="Enter Discount Amount"
                            min="0"
                            step="0"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Percentage of Order Amount<span className="red">*</span></label>
                          <input
                            type="number"
                            name="percentageOrderAmount"
                            className="form-control"
                            value={formValues.percentageOrderAmount}
                            onChange={handleInputChange}
                            placeholder="Enter Percentage of Order Amount"
                            min="0"
                            step="1"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Number of Bookings<span className="red">*</span></label>
                          <input
                            type="number"
                            name="numberOfBookings"
                            className="form-control"
                            value={formValues.numberOfBookings}
                            onChange={handleInputChange}
                            placeholder="Enter Number of Bookings"
                            min="1"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="input-field">
                          <label>Terms and Conditions<span className="red">*</span></label>
                          <textarea
                            name="termsAndConditions"
                            className="form-control h-auto"
                            value={formValues.termsAndConditions}
                            onChange={handleInputChange}
                            placeholder="Enter terms and conditions"
                            required
                          />
                        </div>
                      </div>
                    </>
                  )}

                  <button className="submit-green-btn" type="submit">
                    Submit
                  </button>

                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default AddPlan;